// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__dLtrJ","DesktopOnly":"Toolbar_DesktopOnly__t2elG"};